<template>
  <div class="search-filter">
    <button data-toggle="modal" data-target="#searchFilter" class="btn link-filter p-0">
      <img src="/images/filters.svg" alt="cog-icon" class="ml-1 mb-1 icon-filter" />
      Filters
    </button>

    <div class="modal fade" id="searchFilter" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content p-2">
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="modal-name">Filter by text</div>
              <button
                class="btn btn-cancel float-right"
                data-dismiss="modal"
                aria-label="Close"
              >Cancel</button>
            </div>
            <div class="mb-2">
              <input
                placeholder="Enter designation, name or email..."
                class="form-control"
                type="text"
                v-model="filter.term"
              />
            </div>
            <div class="row mt-3">
              <div class="col-6">
                <button
                  class="btn btn-clear"
                  :disabled="isDisableResetFilter"
                  @click="resetFilter()"
                >Clear filters</button>
              </div>
              <div class="col-6">
                <button
                  class="btn btn-filter"
                  :disabled="isDisableResetFilter"
                  @click="applyFilter()"
                >Filter</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filter: {
        term: ""
      }
    };
  },

  methods: {
    resetFilter() {
      this.filter = {
        term: ""
      };
      this.$emit("filter", this.filter);
    },

    applyFilter() {
      this.$emit("filter", this.filter);
      jQuery("#searchFilter").modal("hide");
    }
  },

  computed: {
    isDisableResetFilter() {
      return this.filter.term === "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/core/mixins";

.search-filter {
  .icon-filter {
    color: #303030;
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;
  }

  .link-filter {
    color: #303030;
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .modal-name {
    color: #303030;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;
  }

  .btn-cancel {
    color: #0db4e6;
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;
  }

  .btn-filter {
    height: 56px;
    background-color: #000000;
    width: 100%;
    color: #ffffff;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    border-radius: 4px;
  }

  .btn-clear {
    height: 56px;
    width: 100%;
    color: #28282e;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    border: 1px solid #28282e;
    border-radius: 4px;
  }
}

$color-accent: #5145ff;

.text-accent {
  color: $color-accent;
}

.bg-accent {
  background-color: $color-accent;
}

@include media-breakpoint-down(sm) {
  .modal-dialog {
    margin: 0;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    max-width: 100%;
  }
}
</style>
